const calcular = (dados) => {
	console.log(dados);

	const valores = {
		Carro: { valor: 23, constante: 15 },
		Moto: { valor: 4.5, constante: 15 },
		Ônibus: { valor: 1.5, constante: 15 },
		papel: { valor: 0.00144, constante: 1 },
		Celular: { valor: 0.02, constante: 1 },
		Computador: { valor: 0.12, constante: 1 },
		Arvores: { economia: 0.5 },
		Reciclagem: { economia: 1 },
		Projetos: { economia: 1 },
		Coletivo: { economia: 2 },
	};

	let total = 0;

	total +=
		((parseInt(dados?.km_mes) || 0) / valores[dados.veiculo].constante) *
		valores[dados.veiculo].valor;

	total +=
		((parseInt(dados?.folhas) || 0) / valores.papel.constante) *
		valores.papel.valor;

	total +=
		((parseInt(dados?.Computador) || 0) / valores.Computador.constante) *
		valores.Computador.valor;

	total +=
		((parseInt(dados?.Celular) || 0) / valores.Celular.constante) *
		valores.Celular.valor;

	total -= dados.checkBox1 ? valores.Arvores.economia : 0;
	total -= dados.checkBox2 ? valores.Reciclagem.economia : 0;
	total -= dados.checkBox3 ? valores.Projetos.economia : 0;
	total -= dados.checkBox4 ? valores.Coletivo.economia : 0;
	console.log(total);
	total += total * 2;
	console.log(total);

	let ano = parseInt(total * 12);
	let comparacao = 100 - parseInt((total * 100) / 2000);
	let comparacaoFinal = Math.abs(comparacao);
	let arvores = parseInt(total / 140) * 12;

	console.table({ ano, comparacao, arvores });

	$(".js-ano span").attr("data-valor", ano / 1000);
	$(".js-comparacao span").attr("data-valor", comparacaoFinal);
	$(".js-arvores span").attr("data-valor", arvores);
	$(".js-comparacao em").html(comparacao > 0 ? "menos" : "mais");
	$(".js-comparacao .up").css("display", comparacao > 0 ? "none" : "inline");
	$(".js-comparacao .down").css("display", comparacao > 0 ? "inline" : "none");

	runAnimations();
};

const animationDuration = 1000;
const frameDuration = 1000 / 60;
const totalFrames = Math.round(animationDuration / frameDuration);
const easeOutQuad = (t) => t * (2 - t);
const animateCountUp = (el) => {
	let frame = 0;
	const countTo = parseInt(el.dataset.valor);
	const counter = setInterval(() => {
		frame++;
		const progress = easeOutQuad(frame / totalFrames);
		const currentCount = Math.round(countTo * progress);
		if (parseInt(el.innerHTML) !== currentCount) {
			el.innerHTML = currentCount;
		}
		if (frame === totalFrames) {
			clearInterval(counter);
		}
	}, frameDuration);
};

const runAnimations = () => {
	const countupEls = document.querySelectorAll(".countup");
	countupEls.forEach(animateCountUp);
};

$(function () {
	$(".js-cpf").mask("000.000.000-00", { reverse: true });
	$("#retURL").val(
		`https://${window.location.host}${window.location.pathname}?enviado=true`
	);
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

	if (urlParams.has("enviado")) {
		$(".form__card").css("display", "none");
		$(".form__card-b").css("display", "block");
		$([document.documentElement, document.body]).animate(
			{
				scrollTop: $(".form__card-b").offset().top - window.innerHeight / 3,
			},
			1000
		);
	}

	const cards = $(".calculadora__card");
	const results = $(".calculadora__results");
	var paragrafoError = $(".MSG");
	const progress = document.querySelector(".calculadora__progress");
	var currentSteps = 0;
	var FormData = {};

	const check = $(".input_check");

	$(".button-geral").click(function (e) {
		e.preventDefault();

		saveFormData(currentSteps);
	});

	$(".Last-button").click(function (e) {
		e.preventDefault();
		saveFormData(currentSteps);
	});

	function saveFormData(step) {
		if (step == 0) {
			const select = $("#Forms1");
			const option = $("#Forms1 option:selected");

			if (option[0].text == "Colaborador") {
				FormData.colaborador = option[0].text;
				cards[step].classList.add("desativado");
				currentSteps++;
				ProxStep(currentSteps);
				currentSteps = 2;
				progress.value = 40;
				error(true, select);
			} else if (option[0].text == "Selecionar função") {
				error(false, select);
				currentSteps = 0;
				progress.value = 0;
			} else {
				FormData.colaborador = option[0].text;
				error(true, select);
				ProxStep(currentSteps);
				currentSteps++;
				progress.value = 20;
			}
		} else if (step == 1) {
			const select = $("#Forms2");
			const option = $("#Forms2 option:selected");
			if (option[0].text == "Selecionar tipo de graduação") {
				error(false, select);
				currentSteps = 1;
			} else {
				FormData.graduação = option[0].text;
				error(true, select);
				ProxStep(currentSteps);
				currentSteps++;
				progress.value = 40;
			}
		} else if (step == 2) {
			const select = $("#Forms3");
			const option = $("#Forms3 option:selected");
			const kmmes = $(".kmes");
			if (option[0].text == "Selecionar veículo" || !kmmes.val()) {
				error(false, select);
				kmmes.css("border-color", "red");
				currentSteps = 2;
			} else {
				FormData.veiculo = option[0].text;
				FormData.km_mes = kmmes.val();
				error(true, select);
				ProxStep(currentSteps);
				currentSteps++;
				progress.value = 60;
			}
		} else if (step == 3) {
			const folhas = $("#folhas");

			if (!folhas.val()) {
				paragrafoError.addClass("MSG-error");
				folhas.css("border-color", "red");
			} else {
				FormData.folhas = folhas.val();
				paragrafoError.removeClass("MSG-error");
				ProxStep(currentSteps);
				currentSteps++;
				progress.value = 80;
			}
		} else if (step == 4) {
			const cargaPc = $("#cargaPc");
			const cargaCell = $("#cargaCell");
			if (!cargaPc.val() && !cargaCell.val()) {
				cargaPc.css("border-color", "red");
				cargaCell.css("border-color", "red");
				paragrafoError.addClass("MSG-error");
			} else {
				paragrafoError.removeClass("MSG-error");
				FormData.Computador = cargaPc.val();
				FormData.Celular = cargaCell.val();
				ProxStep(currentSteps);
				currentSteps++;
				progress.value = 90;
			}
		} else if (step == 5) {
			var checkbox = document.querySelectorAll(".input_check");
			for (var i = 0; i < checkbox.length; i++) {
				if (checkbox[i].checked) {
					if (checkbox[i].value == "Plantar árvores") {
						FormData.checkBox1 = checkbox[i].value;
					} else if (checkbox[i].value == "Reciclagem") {
						FormData.checkBox2 = checkbox[i].value;
					} else if (checkbox[i].value == "Projetos sustentáveis") {
						FormData.checkBox3 = checkbox[i].value;
					} else if (checkbox[i].value == "Transporte Coletivo") {
						FormData.checkBox4 = checkbox[i].value;
					}
				}
			}
			ProxStep(currentSteps);
			progress.value = 100;
			calcular(FormData);
		}
	}

	function error(T, select) {
		if (T) {
			select.removeClass("error");
			paragrafoError.removeClass("MSG-error");
		} else {
			select.addClass("error");
			paragrafoError.addClass("MSG-error");
		}
	}
	function ProxStep(step) {
		cards[step].classList.add("desativado");
		if (cards[step + 1]) {
			cards[step + 1].classList.remove("desativado");
		}
		if (step == 5) {
			cards[step].classList.add("desativado");
			results.removeClass("desativado");
		}
	}

	$(".btn-form-cta").click(function (e) {
		if (!$(".Nome").val()) {
			$(".form__card").removeClass("desativado");
			$(".form__card-b").removeClass("ativo");
			$(".Nome").css("border-color", "red");
		} else {
			$(".Nome").css("border-color", "green");
			FormData.Nome = $(".Nome").val();
		}
		if (!$(".Cpf").val()) {
			$(".form__card").removeClass("desativado");
			$(".form__card-b").removeClass("ativo");
			$(".Cpf").css("border-color", "red");
		} else {
			$(".Cpf").css("border-color", "green");
			FormData.Cpf = $(".Cpf").val();
		}
		if (!$(".Email").val()) {
			$(".form__card").removeClass("desativado");
			$(".form__card-b").removeClass("ativo");
			$(".Email").css("border-color", "red");
		} else {
			$(".Email").css("border-color", "green");
			FormData.Email = $(".Email").val();
		}
		if (!$(".Reduzir").val()) {
			$(".form__card").removeClass("desativado");
			$(".form__card-b").removeClass("ativo");
			$(".Reduzir").css("border-color", "red");
		} else {
			$(".Reduzir").css("border-color", "green");
			FormData.Reduzir = $(".Reduzir").val();
		}
	});

	// Atributos

});

function createModal(t) {
	if (t.length) {
		var o = $("<div>", {
			class: "overlay"
		}),
			a = $("<div>", {
				class: "modal"
			}),
			n = $("<div>", {
				class: "modal-content",
				// decode the html entities on t
				html: t
			}),
			i = $("<span>", {
				class: "close",
				html: "&times;"
			});
		n.append(i), a.append(n), o.append(a),
			$("body").append(o),
			a.show(),
			$(document).on("click", ".close, .overlay", function () {
				o.remove()
			})
	}
}